import { useState } from 'react';

export const useDialog = () => {
    const [extraCloseHandler, setExtraCloseHandler] = useState(() => () => {});
    const resetCloseHandler = () => {
        setExtraCloseHandler(() => () => {
            console.log('setting::dialog::reset');
        });
    };
    return { extraCloseHandler, setExtraCloseHandler, resetCloseHandler };
};
export type useDialogState = ReturnType<typeof useDialog>;
